// "שאלת האריה היומית" — the daily 20-second game (prototype, 29.9.2026).
// One situation a day. Shlomo's voice; texts approved/drafted per
// marketing/daily-lion-situations-v1.md. Day 1 (4.10.2026, Shlomo picked it from
// the values list) is a Claude draft awaiting his three lines; days 2-10 are
// Shlomo's own stories (shaped), days 11-15 are Claude drafts for the 25-45
// audience awaiting his answers (draft: true flags them in the UI until approved).

export type LionDay = {
  id: number;
  line: string; // the situation, one line
  lion: boolean; // is there a lion? (almost always false)
  lionNote?: string; // e.g. "לא, אבל הבטן חושבת שכן"
  feeling: string; // הרגש
  really: string; // מה קרה באמת
  three: string; // שלוש השניות
  card: string; // share card text (humour lands on me, the other is loved)
  draft?: boolean;
};

export const LAUNCH_DATE = "2026-10-05"; // day 1 is shown on this date; earlier dates cycle from day 1

export const LION_DAYS: LionDay[] = [
  {
    id: 1,
    draft: true,
    line: "הזמינו את כולם. לא אותי.",
    lion: false,
    feeling: "עלבון, ואז הרשימה: מי כן, מי לא, ומה זה אומר עליי.",
    really: "רשימת הזמנות היא לא רשימת אהבה. מישהו לחץ \"שלח\" מהטלפון בין שתי שיחות, והשם שלי פשוט לא עלה לו. הבטן קוראת \"הדירו אותי\", כי בשבט זה היה סכנת חיים. היום זה שכחה.",
    three: "להתקשר, לא להיעלב: \"מה נשמע? שמעתי שהייתם.\" או ברוב המקרים: שם שנשכח, ופעם הבאה אני ברשימה.",
    card: "אין כאן אריה, יש רשימת הזמנות ששכחה אותי. ואני, שהתקשרתי לשאול מה נשמע.",
  },
  {
    id: 2,
    line: "הנכד ברכב בדרך לאימון. אני רוצה לדבר, הראש שלו במסך.",
    lion: false,
    feeling: "התפוצצתי. שלוש שנים אני המסיע, ומילה לא יוצאת.",
    really: "מתחת לכעס ישבה מחשבה: \"אם הוא לא מתייחס עכשיו, מי יתייחס כשאהיה זקן? אמות ואיש לא ידע.\" זה לא נכד, זה פחד עתיק, מחופש.",
    three: "פיצוץ לא ילמד אותו להרים את הראש. סבא שקט ליד, שלוש שנים, כן.",
    card: "אין כאן אריה, יש נכד עם טלפון ויש סבא שרוצה שיחה. שלוש שניות, ואני עדיין הנהג האהוב עליו.",
  },
  {
    id: 3,
    line: "נורבגיה, יקר פי שתיים, ואשתי חוזרת עם שקיות מתנות לנכדים.",
    lion: false,
    feeling: "התעלמתי. שיטה: לא נמצא בזמן הקניות, מתעצבן בזמן האריזה.",
    really: "היא לא אוספת שקיות, היא אוספת את הרגע שבו הנכדים פותחים אותן. הגב כואב מהמזוודה, לא מהאהבה שלה. ולהסכם \"שני טרולים בלבד\" תוחלת חיים של טיסה אחת.",
    three: "לסחוב את המזוודה הנוספת עם חיוך. הכסף חוזר, הרגע עם הנכדים לא.",
    card: "אין כאן אריה, יש סבתא שקונה אהבה במשקל. ואני, שלוש שניות יותר חכם, ועם מזוודה נוספת.",
  },
  {
    id: 4,
    line: "הנכדה בת 4 ביקשה שאבוא יותר. באתי. היא בעניינים שלה.",
    lion: false,
    feeling: "קצת נעלב. היא ביקשה, אני כאן, והיא לא מרימה את הראש.",
    really: "ילדה בת 4 חיה בעולם שלה, וזה בריא. ההזמנה שלה הייתה אמיתית, רק לא לפי לוח הזמנים שלי.",
    three: "לא לדרוש תשומת לב, לבנות אותה: \"עם מי שיחקת בגן? מה הבובה החדשה?\" ואט אט היא באה.",
    card: "אין כאן אריה, יש נכדה עסוקה. וסבא שלמד לחכות בתור, ולקבל חיבוק בסוף.",
  },
  {
    id: 5,
    line: "התקשרתי לבן שלי. תפוס. שוב.",
    lion: false,
    feeling: "ציפייה, ואחריה \"התרגלתי\". ציפיות זה לכריות, אומרים.",
    really: "25 מתכנתים מנוהלים על ידו, ומנהלים ממתינים למוצא פיו. הוא לא מתעלם, הוא חי. ואני שמח בזה.",
    three: "לא לוותר על הציפייה, לקחת עליה אחריות. להתקשר שוב, ושוב. תמיד מצליח בסוף.",
    card: "אין כאן אריה, יש בן שמנהל 25 איש. ואבא שמתקשר שוב, כי ציפיות זה לא רק לכריות.",
  },
  {
    id: 6,
    line: "מישהו מתנהג לא לפי הכללים שלי: יושרה, כנות, הגינות. ואני רותח.",
    lion: false,
    feeling: "כעס של שנייה. הוא חצה קו שאני מחזיק בו.",
    really: "הסרגלים הם שלי, לא שלו. מה שמאיים זה לא המעשה שלו, זו ההרגשה שהעולם לא מסודר לפיי.",
    three: "להיזכר שאין אריה בסביבה, ולשים לב שמנגנון הקבלה שלי נחלש. זו ההתחלה של המדיטציה הבאה.",
    card: "אין כאן אריה, יש אדם עם סרגלים אחרים משלי. ואני, עם עוד סיבה טובה למדיטציה.",
  },
  {
    id: 7,
    line: "הכול מעצבן אותי היום. הכול. ואני לא שם לב.",
    lion: false,
    lionNote: "לא, אבל מערכת ההישרדות בטוחה שכן.",
    feeling: "היפראקטיביות של המערכת: כל דבר מפחיד, כל דבר מרגיז, ואני האחרון שיודע. בגלל זה קוראים לה \"לא מודעת\".",
    really: "המערכת נתקעה במצב אזעקה. שעה זה נסבל, שבוע זה באסה.",
    three: "הסכם עם אשתי: כשהיא מזהה, היא משפשפת את תנוך האוזן שלה. סימן מוסכם, בלי מילים. וזה עובד, תשאלו אותה.",
    card: "אין כאן אריה, יש מערכת הישרדות עם קפה חזק מדי. ואשתי משפשפת את האוזן, ואני נרגע.",
  },
  {
    id: 8,
    line: "משימה: להקשיב לאשתי חצי שעה בלי לענות. רק להנהן.",
    lion: false,
    feeling: "מוזר. הפה רוצה לתקן, להוסיף, לפתור.",
    really: "אחרי חצי שעה היא עצרה: \"מה הקטע שלך? אף פעם לא הקשבת לי ככה. וזה היה ממש כיף.\" ואז חיבוק שנמשך ונמשך.",
    three: "להנהן, מילה אחת שמאשרת, ולתת לה להמשיך. Say no more. מאז היא מחקה אותי, ושנינו נהנים.",
    card: "אין כאן אריה, יש אישה עם חצי שעה של דברים לספר. ובעל שגילה שהנהון שווה חיבוק.",
  },
  {
    id: 9,
    line: "\"אתה רוכב כי אתה רוצה או כי אתה צריך?\" שאלה חברה.",
    lion: false,
    feeling: "רגע של בלבול. \"צריך\" נשמע כמו חובה, כמו משהו שכופים עליי.",
    really: "אין צרכים, יש רצונות. גם להוריד את הזבל: את רוצה בית בלי הריח. \"צריך\" מעביר את האחריות למישהו אחר ומשאיר אותי בתדר שלילי.",
    three: "להחליף בראש \"צריך\" ב\"רוצה\". זו בחירה, וזה הניצחון האמיתי. גם ב-120 פעימות בדקה.",
    card: "אין כאן אריה, יש זבל שאני רוצה להוריד. ואופניים שאני רוצה לרכוב. הכול רוצה, וזה משנה הכול.",
  },
  {
    id: 10,
    line: "המנהל הזמין אותי לשיחה. אין לי מושג למה.",
    lion: false,
    lionNote: "לא, אבל הבטן חושבת שכן.",
    feeling: "חרדה. הראש רץ בין קידום לפיטורים בלי שום מידע.",
    really: "אין מידע, יש דמיון. וכשאין מידע, מערכת ההישרדות ממלאת את החלל באיום.",
    three: "להקשיב יותר מלדבר. לתת לו לפתח, למשוך אותו בלשונו. ולפני זה: סימולציה עם אשתי, היא המנהלת.",
    card: "אין כאן אריה, יש מנהל עם שיחה ואישה שמשחקת אותו בסלון. יצאתי מוכן, ועם חצי שעה של צחוק.",
  },
  // ---- drafts for the 25-45 audience (Claude, awaiting Shlomo's answers) ----
  {
    id: 11,
    draft: true,
    line: "שלוש בלילה. התינוקת בוכה בפעם השלישית. בן הזוג לא זז.",
    lion: false,
    feeling: "זעם שקט. \"למה תמיד אני?\"",
    really: "עייפות היא לא ריב, היא עייפות. הוא לא בחר לא לקום, הוא לא שמע. ומערכת ההישרדות שלי, ב-03:00, קוראת כל דבר כבגידה.",
    three: "לקום, להרים אותה, ומחר בבוקר משפט אחד בלי טון: \"הלילה תורך\".",
    card: "אין כאן אריה, יש תינוקת רעבה ובן זוג שישן כמו תינוק. ואני, שלוש שניות יותר חכמה, ומחר ישנה.",
  },
  {
    id: 12,
    draft: true,
    line: "הודעה מהמנהל ב-23:07: \"נדבר מחר בבוקר.\" בלי סימן קריאה, בלי אימוג'י.",
    lion: false,
    lionNote: "לא, אבל השינה כבר הלכה.",
    feeling: "הבטן מתהפכת. שבע גרסאות של מה עשיתי לא בסדר.",
    really: "שבע מילים בלי מידע, והמוח ממלא את החלל בגרוע מכול. הוא כנראה כתב את זה בין שתי הודעות אחרות.",
    three: "לסגור את הטלפון. \"נדבר מחר\" פירושו נדבר מחר. הפחד לא יודע כלום, הוא רק מהיר.",
    card: "אין כאן אריה, יש מנהל שכותב הודעות קצרות. ואני, שלוש שניות יותר חכמה, ועם שבע שעות שינה.",
  },
  {
    id: 13,
    draft: true,
    line: "קבוצת הוואטסאפ של הגן: \"מי לא הביא את החולצה הלבנה?\" ואת יודעת שזו את.",
    lion: false,
    feeling: "בושה, ואז כעס על הבושה.",
    really: "עשרים אמהות, שתיים שכחו, אחת כתבה. אף אחת לא חושבת עלייך, כולן חושבות על עצמן. גם זו שכתבה.",
    three: "\"אני, סליחה, מחר עם החולצה.\" ולסגור את הקבוצה. הילדה בגן שמחה, וזה כל מה שהיה בבוקר.",
    card: "אין כאן אריה, יש חולצה לבנה בכביסה ואמא שעובדת. שלוש שניות, ומחר יש חולצה.",
  },
  {
    id: 14,
    draft: true,
    line: "אמא שלי: \"את בטוחה שהוא צריך ללכת בלי מעיל?\" בפעם השלישית השבוע.",
    lion: false,
    feeling: "עצבים ישנים. \"אני בת 34, אני יודעת מה הילד שלי צריך.\"",
    really: "היא לא בודקת אותך, היא מבקשת להיות צריכה. הדאגה היא הדרך היחידה שהיא יודעת להיות סבתא.",
    three: "\"אמא, תודה שאת דואגת. הוא בסדר.\" ולעבור הלאה. שני משפטים, אפס ריב, וסבתא שקיבלה את מה שבאה בשבילו.",
    card: "אין כאן אריה, יש סבתא שדואגת בקול. ואני, שלוש שניות יותר חכמה, ועם ילד בלי מעיל.",
  },
  {
    id: 15,
    draft: true,
    line: "הדייט מאתמול לא כתב. 19 שעות. הטלפון שקט.",
    lion: false,
    feeling: "ריקנות, ואז נאום פנימי על כל מה שלא בסדר בי.",
    really: "19 שעות של שקט הן 19 שעות של שקט. הסיפור על \"מה לא בסדר בי\" כתוב מראש, ומחכה לכל שקט כדי לצאת.",
    three: "לשים את הטלפון בחדר השני. אם יכתוב, נחמד. אם לא, זה מידע עליו, לא עלייך.",
    card: "אין כאן אריה, יש טלפון שקט ויש אני, שלוש שניות יותר חכמה, ועם ערב פנוי.",
  },
];

// Which day to show today. Before launch: cycle through the list by date so
// testers see a different day each day.
export function dayIndexFor(date: Date): number {
  const start = new Date(LAUNCH_DATE + "T00:00:00");
  const ms = date.getTime() - start.getTime();
  const days = Math.floor(ms / 86400000);
  const n = LION_DAYS.length;
  return ((days % n) + n) % n;
}
